(() => {
  const initCustomLayoutSlider = (swiperEl) => {
    if (!swiperEl || swiperEl.dataset.sliderInitialized === 'true' || typeof Swiper === 'undefined') return;

    const tabs = document.querySelector('#custom-layout-tabs');
    const tabButtons = tabs ? tabs.querySelectorAll('.custom-layout-tab') : [];
    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1,
      speed: 400,
      autoHeight: false,
      observer: false,
      observeParents: false,
      preventClicks: false,
      preventClicksPropagation: false,
    });

    swiperEl.dataset.sliderInitialized = 'true';

    tabButtons.forEach((tab) => {
      const slideIndex = parseInt(tab.dataset.slideIndex, 10) || 0;
      tab.addEventListener('click', () => swiper.slideTo(slideIndex));
      tab.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          swiper.slideTo(slideIndex);
        }
      });
    });

    swiper.on('slideChange', () => {
      tabButtons.forEach((tab) => {
        const isActive = (parseInt(tab.dataset.slideIndex, 10) || 0) === swiper.realIndex;
        tab.classList.toggle('is-active', isActive);

        if (isActive && tabs) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  };

  const setupCustomLayoutSlider = () => {
    const swiperEl = document.querySelector('#custom-layout-swiper');
    if (!swiperEl) return;

    if (!('IntersectionObserver' in window)) {
      initCustomLayoutSlider(swiperEl);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        initCustomLayoutSlider(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    observer.observe(swiperEl);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCustomLayoutSlider);
  } else {
    setupCustomLayoutSlider();
  }

  document.addEventListener('shopify:section:load', setupCustomLayoutSlider);
})();
